export default __webpack_public_path__ + "static/media/info.57d7cb70.svg";